module.exports = __webpack_public_path__ + "static/img/wangzhezuqiu.5c6bd2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/wangzhezuqiu.jpg
// module id = 9sIl
// module chunks = 0